<template>
  <div class="home h-100">
    <!-- Navigation -->
    <Navbar />
    <section class="hero-header h-100">
      <div class="container">
            <div class="description text-center">
                <h1 class="policy">Coralstone Terms & Conditions</h1>
            </div>
        </div>
    </section>

    <!-- why work with us -->
    <section class="privacy">
      <div class="container">
        <div class="row">
          <div class="col-md-4 order-2 order-md-1">
              <div class="sidebar-left" id="sidebar-left">
                <ul class="list-unstyled sidebar-content">
                  <li><a href="#introductions" class="nav-link">Introductions</a></li>
                  <li><a href="#accuracyInfo" class="nav-link">Accuracy of information</a></li>
                  <li><a href="#confidentiality" class="nav-link">Confidentiality</a></li>
                  <li><a href="#monitoringCoralstone" class="nav-link">Monitoring by Coralstone Capital</a></li>
                  <li><a href="#websiteContent" class="nav-link">Website content and materials</a></li>
                  <li><a href="#doUseCookies" class="nav-link">Do we use Cookies?</a></li>
                  <li><a href="#howUseCookies" class="nav-link">How We Use Cookies</a></li>
                  <li><a href="#security" class="nav-link">No warranties made as to the security</a></li>
                  <li><a href="#warranties" class="nav-link">No warranties; no responsibilities to update</a></li>
                  <li><a href="#recommendation" class="nav-link">Content not to be construed as a solicitation or recommendation</a></li>
                  <li><a href="#advisors" class="nav-link">No determination of suitability has been made; not all risks are disclosed; private advisors should be consulted</a></li>
                  <li><a href="#copyright" class="nav-link">Copyright notice</a></li>
                  <li><a href="#linksFromWebsite" class="nav-link">Links from this website</a></li>
                  <li><a href="#liability" class="nav-link">Limitation of liability
</a></li>
                  <li><a href="#governingLaw" class="nav-link">Governing law</a></li>
                  <li><a href="#waiver" class="nav-link">No waiver</a></li>
                  <li><a href="#notification" class="nav-link">Termination and notification of changes</a></li>
                  <li><a href="#contact" class="nav-link">Contact</a></li>
              </ul>
              </div>
          </div>
          <div class="col-md-8 order-1 order-md-2">
            <div class="main-text">
                <div class="content" id="introductions">
                    <h3>Introductions</h3>
                    <p>Any person or group of persons who access or rely on this Website or the information contained herein does so at their own risk.</p>

                    <p>By accessing this Website You are deemed to have read and agreed to the following terms and conditions below. These terms and conditions become effective when you access this site for the first time. These Terms and Conditions are subject to change without notice, from time to time in our sole discretion. You are responsible for being familiar with the current version of these Terms and Conditions posted on the Website during each visit.</p>

                    <p>If you do not wish to be bound by these terms and conditions, do not access this website.</p>

                    <p>You are strictly prohibited from unauthorized use of our systems or this Website, including but not limited to unauthorized entry into our systems, misuse of passwords, or misuse of any information posted to this Website.</p>

                    <P>These terms of use should be read in conjunction with the Privacy Policy.
                    </p>
                </div>

                <div class="content" id="accuracyInfo">
                    <h3>Accuracy of information</h3>
                    <p>While Coralstone Capital attempts to ensure that the information on this Website is accurate, current, complete, fit for its intended purpose and compliant with the relevant Nigerian Legislation and regulations as at the time of access, this site and the online services are provided “as is”. Coralstone Capital makes no representation or warranty, whether express or implied as to the accuracy, completeness or reliability of any information on this website.:</p>

                </div>

                <div class="content" id="confidentiality">
                    <h3>Confidentiality</h3>
                    <p>Information provided by you shall be kept confidential and not be used or disclosed in any manner incompatible with the purposes for which they are held. Notwithstanding, You acknowledge that we may disclose and transfer any information that you provide through this Website to (i) the Company, its affiliates, agents or information providers; or (ii) if we have a right or duty to disclose or are permitted or compelled to so disclose such information by law. You consent to the transmission, transfer or processing of such information to, or through, any country in the world, as we deem necessary or appropriate, and by using and providing information through this Website you agree to such transfers.</p>  
                </div>

                 <div class="content" id="monitoringCoralstone">
                    <h3>Monitoring by Coralstone Capital</h3>
                    <p>Your use of the products and services on this Website may be monitored by the Company and the resultant information may be used by the Company for its internal business purposes or following the rules of any applicable regulatory or self-regulatory organization. Anyone using this Website expressly consents to such monitoring, tracking and recording.</p>
                   
                </div>

                <div class="content" id="websiteContent">
                    <h3>Website content and materials</h3>
                    <p>You are permitted to store, display, analyze, modify, reformat, and print the information made available to you via these services for your use only. You are by no means, permitted to publish, transmit, or otherwise reproduce this information, in whole or in part, in any format to any third party without the express written consent of Coralstone Capital. Also, you are not permitted to alter, obscure, or remove any copyright, trademark or any other notices that are provided to you in connection with the information contained on this Website. The Company reserves the right, at any time and from time to time, in the interests of its editorial discretion and business judgment to add, modify, or remove any of the information without recourse to You. These Terms and Conditions are not intended to, and will not, transfer or grant any rights in or to the information other than those which are expressly described herein, and all rights not expressly granted herein are automatically reserved by Coralstone Capital or any third party providers from whom the Company has obtained the information. You are advised to read and abide by any revised or additional terms and conditions that may be posted on this service from time to time concerning information generated by the Company or obtained from specific third party providers. Such third party providers shall have no liability to you for monetary damages on account of the information provided to you via this service.</p>
                </div>
                 <div class="content" id="security">
                    <h3>No warranties made as to the security</h3>
                    <p>Coralstone Capital makes no warranty whatsoever to you express or implied, regarding the security of the site, including concerning the ability of unauthorized persons to intercept or access information transmitted by you through this service. Coralstone Capital also makes no warranty or representation, whether express or implied, that the information or files available on this Website are free of viruses, destructive materials or any other data or code which can corrupt, compromise, jeopardize, disrupt, disable, harm or otherwise impede in any manner the operation of a computer system, computer network or your hardware or software. You accept all risk associated with the existence of such viruses, destructive materials or any other data or code which can corrupt, compromise, jeopardize, disrupt, disable, harm or otherwise impede in any manner the operation or content of a computer system, computer network or your hardware or software.</p>
                </div>
                <div class="content" id="warranty">
                    <h3>No warranties; no responsibilities to update</h3>
                    <p>Coralstone Capital makes no warranty, express or implied, concerning this service. The services provided by us are on an “AS IS” basis at your sole risk. The Company expressly disclaims any implied warranty of merchantability or fitness for a particular purpose, including any warranty for the use or the results of the use of the services concerning their correctness, quality, accuracy, completeness, reliability, performance, timeliness, or continued availability.</p>
                </div>

                <div class="content" id="linkToWebsites">
                    <h3>Links to other websites</h3>
                    <p>Our Site may contain links to other websites of interest. However, once You have used these links to leave Our Site, You should note that We do not have any control over such websites. Therefore, We cannot be responsible for the protection and privacy of any information which You provide whilst visiting such websites and such websites are not governed by this Privacy Policy. You should exercise caution and review the privacy statement(s) applicable to the websites.</p>
                    <p>Neither Coralstone Capital nor any of its third party providers shall have any responsibility to maintain the data and services made available on this Web site or to supply any corrections, updates, or releases in connection therewith. Availability of data and services are subject to change without notice.</p>
                    <p>Please remember that past performance is not necessarily a guide to future performance, and that there can be no assurance that comparable results will be achieved. The value of units of securities and/or investments and the income from them can go down as well as up and investors may not get back the amount originally invested. Exchange rate changes may cause the value of investments made by offshore investors to rise or fall. For further details on any of the products mentioned on this Website, please read the relevant offering documents or prospectus.</p>
                </div>

                <div class="content" id="recommendation">
                    <h3>Content not to be construed as a solicitation or recommendation</h3>
                    <p>Content on this Website is for informational purposes only without regard to any particular user’s investment objectives, financial situation, or means, and Coralstone Capital is not soliciting any action based upon it. Information is not to be construed as a recommendation; or an offer to buy or sell; or the solicitation of an offer to buy or sell any security, financial product, or instrument; or to participate in any particular trading strategy in any jurisdiction in which such an offer or solicitation, or trading strategy would be illegal. Certain transactions give rise to substantial risk and are not suitable for all investors.</p>
                </div>

                <div class="content" id="advisors">
                    <h3>No determination of suitability has been made; not all risks are disclosed; private advisors should be consulted</h3>
                    <p>The fact that Coralstone Capital has made the data and services provided on this Website available to you constitutes neither a recommendation that You enter into a particular transaction nor a representation that any product described on this Website is suitable or appropriate for you. Many of the products described on this Website involve significant risks, and you should not enter into any transactions unless you have fully understood all such risks and have independently determined that such transactions are appropriate for you. Any discussion of the risks contained herein concerning any product should not be considered to be a disclosure of all risks or complete discussion of the risks which are mentioned. You should not construe any of the material contained herein as business, financial, investment, hedging, trading, legal, regulatory, tax, or accounting advice nor make this service the primary basis for any investment decisions made by or on behalf of you, your accountants, or your managed or fiduciary accounts, and you may want to consult your business advisor, attorney, and tax and accounting advisors concerning any contemplated transactions.</p>
                </div>

                <div class="content" id="copyright">
                    <h3>Copyright notice</h3>
                    <p>Copyright and other relevant intellectual property rights exist on all text relating to the Company’s services and the full content of this website.</p>
                    <p>Potential disruption of service</p>
                    <p>You shall be responsible for obtaining and maintaining all telephone, computer hardware, software, and other equipment needed to access and use this Website. Access to this Website may from time to time be unavailable, delayed, limited or slow due to, among other things:</p>
                    <ul>
                        <li>hardware failure, including among other things, failures of computers (including your computer), servers, networks, telecommunication lines and connections, and other electronic and mechanical equipment</li>
                        <li>software failure, including among other things, bugs, errors, viruses, configuration problems, incompatibility of systems, utilities or applications, the operation of firewalls or screening programs, unreadable codes, or irregularities within particular documents or other content</li>
                        <li>overload of system capacities</li>
                        <li>damage caused by severe weather, earthquakes, wars, insurrection, riots, terrorism, civil commotion, an act of God, accident, fire, water damage, explosion, mechanical breakdown or natural disasters</li>
                        <li>interruption (whether partial or total) of power supplies or other utility of service</li>
                        <li>strike or other stoppages (whether partial or total) of labour</li>
                        <li>governmental or regulatory restrictions, exchange rulings, court or tribunal orders or other human intervention; or</li>
                        <li>any other cause (whether similar or dissimilar to any of the foregoing) whatsoever beyond our control.</li>
                    </ul>
                    <p>If access to this Website is unavailable, delayed or limited or if this Website does not operate quickly and efficiently, you may be unable to transmit your instructions for transactions and other matters, or such instructions may not be promptly executed or you may be unable to retrieve information on a timely basis. If your operations are dependent on such communications with Us, and such communications are disrupted or delayed, you may suffer losses. Coralstone Capital shall not be liable for any such loss.</p>
                </div>

                <div class="content" id="linksFromWebsite">
                    <h3>Links from this website</h3>
                    <p>This service may provide links to certain Internet sites (the “Sites”) sponsored and maintained by third parties. Coralstone Capital is providing such links solely for convenience to You. Accordingly, Coralstone Capital makes no representations concerning the content of the Sites. We do not monitor or review the content of other party’s Sites which are linked to from this website. Opinions expressed or materials appearing on such sites do not constitute an endorsement by us and should not be regarded as the publisher of such opinions or materials. Please be aware that We are not responsible for the privacy practices, or content, of these sites. We encourage You to be aware when they leave our site & to read the privacy statements of these sites. You should evaluate the security and trustworthiness of any other site connected to this site or accessed through this site yourself, before disclosing any personal information to them. The Company will not accept any responsibility for any loss or damage in whatever manner, howsoever caused, resulting from your disclosure to third parties of personal information.</p>
                </div>

                <div class="content" id="liability">
                    <h3>Limitation of liability</h3>
                    <p>Coralstone Capital shall have no liability, contingent or otherwise, to You or third parties, or any responsibility whatsoever, for the failure of any connection or communication service to provide or maintain your access to this service, or for any interruption or disruption of such access or any erroneous communication between the Company and You, regardless of whether the connection or communication service is provided by the Company or a third-party service provider. Coralstone Capital shall have no liability, contingent or otherwise, to You or third parties, for the correctness, quality, accuracy, timeliness, reliability, performance, continued availability, completeness or delays, omissions, or interruptions in the delivery of the data and services available on this website or for any other aspect of the performance of this service or any failure or delay in the execution of any transactions through this service. In no event shall the Company be liable for any special, indirect, incidental, or consequential damages which may be incurred or experienced on account of You using the data or services made available on this Website, even where the Company has been advised of the possibility of such damages. Coralstone Capital shall have no responsibility to inform You of any difficulties experienced by the Company or third parties concerning the use of the services or to take any action in connection therewith</p>
                </div>
                 <div class="content" id="governingLaw">
                    <h3>Governing law</h3>
                    <p>In the event any of the terms or provisions of these Terms and Conditions shall be held to be unenforceable, the remaining terms and provisions shall be unimpaired and the unenforceable term or provision shall be replaced by such enforceable term or provision as comes closest to the intention underlying the unenforceable term or provision. These Terms and Conditions shall be subject to any other agreements you have entered into with the Company. The user’s access to and use of the Website, and the terms of this disclaimer are governed by the laws of the Federal Republic of Nigeria without regards to the conflict of law provisions.
You consent to the personal and exclusive jurisdiction of the courts located within the Lagos State of Nigeria.
</p>
                    
                </div>
               
                <div class="content" id="waiver">
                    <h3>No waiver</h3>
                    <p>The Company’s failure to exercise or enforce any right or provision of the Terms of Service shall not constitute a waiver of such right or provision or prevent a subsequent enforcement of that or any other right or provision. No waiver of any of the provisions of this or any Agreement shall be effective unless it is expressly stated to be such and signed by both Parties.</p>
                    
                </div>

                 <div class="content" id="notification">
                    <h3>Termination and notification of changes</h3>
                    <p>Coralstone Capital may in its sole discretion terminate, suspend and/or modify the contents of this Website with or without notice to you. The Company reserves the right to terminate, suspend and/or modify these conditions from time to time as it sees fit and your continued use of the site will signify your acceptance of any adjustment to these terms. You agree that Coralstone Capital, its affiliates or subsidiaries shall not be liable to you in the event it chooses to terminate, suspend or modify this Website or your use of this Website</p>
                    
                </div>
                <div class="content" id="contact">
                    <h3>Contact</h3>
                    <p>For questions, concerns, comments and requests regarding this privacy policy, please contact us through the details below:</p>
                    <p>Email: support@coralstone.capital<br>
                    Call: +234 (0) 816 935 2843 +234<br>
                    Please note response will be shared within 30 days of receiving your feedback.
                    </p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import Navbar from "../components/Navbar.vue";

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer
  },
  mounted() {
      this.fixedSidebar()
  },
  methods: {
      fixedSidebar() {
        //const sidebar = document.querySelector('.sidebar-content');
        // window.addEventListener('scroll', function() {
        //     //let windowScrollPosition = window.scrollY;
        //     //let sidebarPosition = sidebar.scrollTop
        //     //console.log(windowScrollPosition)
        //     //onsole.log(sidebarPosition);
        //     // if(windowScrollPosition > 550) {
        //     //    //console.log('yed') 
        //     //     sidebar.classList.add('stickySidebar')
        //     // } else {
        //     //     //console.log('No')
        //     //     sidebar.classList.remove('stickySidebar')
        //     // }
        // })
      }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .hero-header {
      background-image: url("../../public/img/terms-hero-header.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding-top: 10rem;

      .description {
          color: #fff;

          h1 {
              font-family: 'Poppins', sans-serif;
              font-weight: bold;
              font-size: 64px;
              line-height: 96px;
              letter-spacing: 0.02em;
          }

          p {
              font-family: 'Poppins', sans-serif;
              font-size: 22px;
              line-height: 32px;
              padding: 0 15rem;
              text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          }

          .policy {
            font-size: 56px;
          }
      }
  }

  // privacy styles
  
  .privacy {
    padding: 2rem 0 4rem;

    .sidebar-left {
        background: #D8DCF3;
        padding: 0.5rem;
        position: relative;
        border-radius: 16px;
         

        .sidebar-content {
            //position: fixed;

            li {
                .nav-link {
                    color: #28283A;
                    font-weight: 500;

                    &:hover {
                    color: #2C3C90;
                    }
                }
            }
        }

        // .sidebar-content.stickySidebar {
        //     background: #e75c5c;
        //     position: fixed;
        //     width: 25%;
        //     top: 0;
        //     bottom: 0;
        //     height: 100vh;
        //    overflow-y: scroll;
        // }
    }

    .main-text {
      h3 {
        font-weight: bold;
        font-size: 28px;
        line-height: 28px;
        letter-spacing: 0.02em;
        color: map-get($colors, deep-blue);
        padding-top: 5.3rem;
      }

      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: px;
        color: #28283A;
      }

      #introductions {
        h3 {
          padding-top: 0;
        }
      }

    }
  }


  @media (min-width: 992px) and (max-width: 1199px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 64px;
                line-height: 96px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 10rem;
            }
        }
    }

    .privacy {
      margin-top: -1rem;
    }

  }


  @media (min-width: 767px) and (max-width: 991px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 52px;
                line-height: 76px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 5rem;
            }

            .policy {
              font-size: 38px;
            }
        }
    }

    .privacy {

      .main-text {
        h3 {
          font-size: 24px;
        }
      }
    }

    
  }

  @media (max-width: 767px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 42px;
                line-height: 57px;
            }

            p {
                font-size: 20px;
                line-height: 32px;
                padding: 0 3rem;
            }

            .policy {
              font-size: 31px;
            }
        }
    }

    

    .privacy {
      margin-top: -4rem;

      .main-text {
        h3 {
          font-size: 20px;
        }

         #introductions {
          h3 {
            padding-top: 4.3rem;
          }
        }
      }
    }

    

    
  }

  @media (max-width: 575px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        //padding-top: 6rem;

        .description {

            h1 {
                line-height: 46px;
            }

        }
    }

    
  }

  @media (max-width: 375px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");

        .description {

            h1 {
                font-size: 35px;
            }

            p {
                font-size: 17px;
                padding: 0 2rem;
            }
        }
    }

    
  }


</style>

